/* import __COLOCATED_TEMPLATE__ from './manager.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

// Max twoFactorTimestamp age of 5 minutes allowed for taking action on 2FA management options.
export const MAX_TWO_FACTOR_TIMESTAMP_AGE_IN_MILLIS = 5 * 60 * 1000;
let TwoFactorModalManagerComponent = (_dec = service('ember-multipass-flag'), _dec2 = service('ember-multipass-logging'), _dec3 = service('ember-multipassfe-client'), _class = class TwoFactorModalManagerComponent extends Component {
  // fn to be called after refreshing two factor

  get canDisablePersonalRequirement() {
    return this.args.canDisable ?? this.multipassfeClient.canDisablePersonalRequirement;
  }
  get smsDetails() {
    return this.multipassfeClient.twoFactorDetails?.filter(x => x.sms) || [];
  }
  get authAppDetails() {
    return this.multipassfeClient.twoFactorDetails?.filter(x => x.googleauth) || [];
  }
  get hasAuthApp() {
    return this.authAppDetails.length > 0;
  }
  get canRemoveTwoFactorMethod() {
    return this.multipassfeClient.twoFactorDetails?.length > 1;
  }
  get needsToRefreshTwoFactor() {
    return this.multipassfeClient.needsToUpgradeTwoFactor(MAX_TWO_FACTOR_TIMESTAMP_AGE_IN_MILLIS);
  }
  get privacyPolicyUrl() {
    return this.multipassfeClient.constants.PRIVACY_POLICY_URL;
  }
  get termsAndConditionsUrl() {
    return this.multipassfeClient.constants.TERMS_AND_CONDITIONS_URL;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "flags", _descriptor3, this);
    _initializerDefineProperty(this, "logger", _descriptor4, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor5, this);
    _initializerDefineProperty(this, "disableConfirmModalOpen", _descriptor6, this);
    _initializerDefineProperty(this, "detailRemoveModalOpen", _descriptor7, this);
    _initializerDefineProperty(this, "enrollModalOpen", _descriptor8, this);
    _initializerDefineProperty(this, "enrollSecureContactModalOpen", _descriptor9, this);
    _initializerDefineProperty(this, "optInMessagingConfirmModalOpen", _descriptor10, this);
    _defineProperty(this, "methodsToEnroll", Object.freeze({
      SMS: 'SMS',
      AUTH_APP: 'AUTH_APP'
    }));
    _initializerDefineProperty(this, "methodToEnroll", _descriptor11, this);
    _initializerDefineProperty(this, "detailToRemove", _descriptor12, this);
    _initializerDefineProperty(this, "detailToOptIn", _descriptor13, this);
    _initializerDefineProperty(this, "disableOptIn", _descriptor14, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor15, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor16, this);
    _initializerDefineProperty(this, "refreshTwoFactorModalOpen", _descriptor17, this);
    _initializerDefineProperty(this, "refreshTwoFactorCallback", _descriptor18, this);
  }

  /**
   * Handle checking of two factor refresh requirement and subsequent calling of desired callback
   */
  handleRefreshTwoFactorCheck(callback) {
    if (this.needsToRefreshTwoFactor) {
      this.refreshTwoFactorCallback = callback;
      this.handleRefreshTwoFactorModalOpen();
      return;
    }
    callback();
  }
  handleRefreshTwoFactorModalOpen() {
    this.refreshTwoFactorModalOpen = true;
  }

  /**
   * Handle post 2FA refresh flow by verifying 2FA was upgraded and calling callback func
   */
  handleRefreshTwoFactorModalClose() {
    this.refreshTwoFactorModalOpen = false;
    const callback = this.refreshTwoFactorCallback;
    // Check if 2FA was actually refreshed, if so, proceed with action callback
    if (!this.needsToRefreshTwoFactor && callback) {
      callback();
    }
    this.refreshTwoFactorCallback = undefined;
  }
  handleDisableConfirmModalOpen() {
    this.handleRefreshTwoFactorCheck(() => this.disableConfirmModalOpen = true);
  }
  handleDisableConfirmModalClose() {
    this.disableConfirmModalOpen = false;
  }
  handleEnrollModalOpen() {
    this.handleRefreshTwoFactorCheck(() => this.enrollModalOpen = true);
  }
  handleEnrollModalClose({
    dualEnrollSecureContactPhone = false,
    phoneNumber = '',
    phoneNumberDisplay = ''
  }) {
    this.enrollModalOpen = false;
    if (dualEnrollSecureContactPhone) {
      this.phoneNumber = phoneNumber;
      this.phoneNumberDisplay = phoneNumberDisplay;
      this.enrollSecureContactModalOpen = true;
    }
  }
  handleEnrollSecureContactModalClose() {
    this.enrollSecureContactModalOpen = false;
  }
  handleOptInMessagingConfirmModalOpen() {
    this.optInMessagingConfirmModalOpen = true;
  }
  handleOptInMessagingConfirmModalClose() {
    this.optInMessagingConfirmModalOpen = false;
  }
  handleRemoveDetailModalOpen() {
    this.handleRefreshTwoFactorCheck(() => this.detailRemoveModalOpen = true);
  }
  handleRemoveDetailModalClose() {
    this.detailRemoveModalOpen = false;
  }
  handleCloseAllModals() {
    this.disableConfirmModalOpen = false;
    this.args.close();
  }
  handleEnrollSms() {
    this.methodToEnroll = this.methodsToEnroll.SMS;
    this.handleEnrollModalOpen();
  }
  handleEnrollAuthApp() {
    this.methodToEnroll = this.methodsToEnroll.AUTH_APP;
    this.handleEnrollModalOpen();
  }
  async handleOptInMessaging(detail) {
    this.detailToOptIn = detail;
    // Prevent other opt-in buttons from being clicked
    this.disableOptIn = true;
    try {
      await this.multipassfeClient.managePhoneDetail({
        phone: detail.sms.phone,
        action: this.multipassfeClient.constants.MANAGE_PHONE_DETAIL_ACTIONS.UNBLOCK
      });
      await this.multipassfeClient.listTwoFactor();
      this.handleOptInMessagingConfirmModalOpen();
    } catch (error) {
      this.logger.error('Failed to update phone detail messaging', error);
      this.marketToasts.critical(this.intl.t(this.args.tPrefix + 'two_factor_modals.toasts.errors.unknown'));
    } finally {
      this.disableOptIn = false;
    }
  }
  handleRemoveDetail(detail) {
    this.detailToRemove = detail;
    this.handleRefreshTwoFactorCheck(() => this.handleRemoveDetailModalOpen());
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flags", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "disableConfirmModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "detailRemoveModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "enrollModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "enrollSecureContactModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "optInMessagingConfirmModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "methodToEnroll", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.methodsToEnroll.SMS;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "detailToRemove", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "detailToOptIn", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "disableOptIn", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "refreshTwoFactorModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "refreshTwoFactorCallback", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleRefreshTwoFactorCheck", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRefreshTwoFactorCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRefreshTwoFactorModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRefreshTwoFactorModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRefreshTwoFactorModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRefreshTwoFactorModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDisableConfirmModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDisableConfirmModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDisableConfirmModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDisableConfirmModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollSecureContactModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollSecureContactModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOptInMessagingConfirmModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOptInMessagingConfirmModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOptInMessagingConfirmModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOptInMessagingConfirmModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRemoveDetailModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRemoveDetailModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRemoveDetailModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRemoveDetailModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCloseAllModals", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCloseAllModals"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollSms", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollSms"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollAuthApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollAuthApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOptInMessaging", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOptInMessaging"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRemoveDetail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRemoveDetail"), _class.prototype), _class);
export { TwoFactorModalManagerComponent as default };